import React from 'react'

const NotFound = () => {
  return (
    <div className='text-5xl to-red-700'>NotFound</div>
  )
}

export default NotFound